<div class="best-fare-options">
  <idp-select-mach-core
    [hasInfoTooltip]="true"
    [disabled]="disabled"
    [title]="title"
    [dropdownOptions]="dropdownOptions"
    [infoModalContent]="infoModalContent"
    [infoTooltipOptions]="infoTooltipOptions"
    (selectionChange)="bestFareOptionsChange.emit($event)"
  ></idp-select-mach-core>
</div>
